import { IRootState } from '../../../store'
import { ILocationSearchState } from '../store/locationSearch.types'

export const getLocationSearchState = (state: IRootState): ILocationSearchState => state.locationSearch
